import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { ATTACHMENT_API } from "./apiRoutes";

interface UseGetAttachmentWithEntityProps {
  entityType: string;
  entityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getAttachmentWithEntity = async (entityId: string, entityType: string) =>
  await axiosAuth.get(`${ATTACHMENT_API}/entity`, {
    params: {
      entityType,
      entityId,
    },
  });

const useGetAttachmentWithEntity = ({
  queryParams,
  entityType,
  entityId,
}: UseGetAttachmentWithEntityProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["attachment", entityId, entityType],
    queryFn: () => getAttachmentWithEntity(entityId, entityType),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!entityId || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetAttachmentWithEntity;
